import Axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

const divStyle = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	backgroundSize: "cover",
	height: "100vh",
};

export default function Home() {
	const [data, setData] = useState([]);
	const navigate = useNavigate();

	let api = process.env.REACT_APP_API_URL || "http://localhost:4000";

	useEffect(() => {
		Axios.get(api + "/retrieveAds").then((response) => {
			setData(response.data);
		});
	}, [api]);

	async function handleSensor() {
		const response = await Axios.get(api + "/sensor");
		if (response.status === 200) {
			if (response.data) {
				clearInterval(sensor);
				navigate("/main");
			}
		} else {
			console.log("error");
		}
	}

	let sensor = setInterval(() => {
		try {
			handleSensor();
		} catch (error) {
			console.log(error);
		}
	}, 5000);

	useEffect(() => {
		return () => {
			clearInterval(sensor);
		};
	}, [sensor]);

	return (
		<div className="w-full h-full">
			{data.length > 0 ? (
				<Slide>
					{data.map((slideImage, index) => (
						<div key={index}>
							<div
								style={{
									...divStyle,
									backgroundImage: `url(${slideImage.imageUrl})`,
								}}
							></div>
						</div>
					))}
				</Slide>
			) : (
				<div className="w-full h-full bg-gray-500"></div>
			)}
			<Link
				to="/main"
				className="flex justify-center items-end text-2xl text-white font-black top-0 left-0 absolute h-full w-full bg-gradient-to-b from-black/[0] to-black/[0.8] z-10 p-10"
			>
				Click to begin!
			</Link>
		</div>
	);
}
